import React from "react";
import {useRoutes} from "react-router-dom";
import SignUp from "./pages/SignUp";
import LandingPage from "./pages/Landing";
import AboutUs from "./pages/AboutUs";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Policy from "./pages/Policy";
import ContactUs from "./pages/ContactUs";
import NewsEditor from "./admin/news";
import Services from "./pages/Services";
import Cellbank from "./pages/Cellbank";
import Genetic from "./pages/Genetic";
import Therapy from "./pages/Therapy";
import TextEditor from "./admin/news";
import Booking from "./pages/Booking";

const ProjectRoutes = () => {
    let element = useRoutes([
        { path: "signup", element: <SignUp></SignUp> },
        { path: "/", element: <LandingPage></LandingPage> },
        { path: "about", element: <AboutUs></AboutUs> },
        { path: "news", element: <News></News> },
        { path: "news/:id", element: <NewsDetail></NewsDetail> },
        { path: "policy/:id", element: <Policy /> },
        { path: "contact", element: <ContactUs /> },
        { path: "import", element: <NewsEditor /> },
        { path: "cellbank", element: <Cellbank /> },
        { path: "genetic", element: <Genetic /> },
        { path: "therapy", element: <Therapy /> },
        { path: "services", element: <Services /> },
        { path: "admin", element: <TextEditor /> },
        { path: "booking", element: <Booking /> }
    ]);
    return element;
}

export default ProjectRoutes;